import React, { useState } from "react";
import { ArrowLeft, Send } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { sendFeedback } from "../service/FormService";
import { feedbackMap } from "../constants/Constants";

const fields = [
    { key: "title", type: "text" },
    { key: "clarity", type: "text" },
    { key: "mostValuable", type: "text" },
    { key: "tools", type: "textarea" },
    { key: "howOften", type: "text" },
    { key: "useAgain", type: "textarea" },
    { key: "improvements", type: "textarea" },
];

export default function FeedbackForm() {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        title: "", clarity: "", mostValuable: "", tools: "",
        howOften: "", useAgain: "", improvements: "", name: "", followUpEmail: "",
    });
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (key, value) => setForm(f => ({ ...f, [key]: value }));

    const handleSubmit = async () => {
        setSubmitting(true);
        setError("");
        try {
            const res = await sendFeedback(form, true);
            if (res.success) {
                setSubmitted(true);
            } else {
                setError("Failed to submit feedback. Please try again.");
            }
        } catch {
            setError("Failed to submit feedback. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="home-layout">
            <Sidebar activePage="Feedback" />

            <main className="home-main">
                <Header />

                <div className="home-content">
                    <div className="upload-main">
                        <button className="chpw-back" onClick={() => navigate("/")}>
                            <ArrowLeft size={14} />
                            Back to Dashboard
                        </button>

                        <div className="upload-page-title-row">
                            <div>
                                <h1 className="upload-page-heading">Feedback</h1>
                                <p className="upload-page-meta">Help us improve DeepThought by sharing your experience.</p>
                            </div>
                        </div>

                        {submitted ? (
                            <div className="submissions-card" style={{ padding: "40px 24px", textAlign: "center" }}>
                                <Send size={32} color="#5ecfa0" />
                                <p style={{ fontSize: 16, fontWeight: 600, marginTop: 16, color: "var(--ink-900)" }}>Thank you for your feedback!</p>
                                <p style={{ fontSize: 13, color: "var(--ink-400)", marginTop: 4 }}>Your responses help us build a better tool for researchers.</p>
                                <button className="start-analysis-btn" style={{ marginTop: 20, width: "auto", padding: "10px 24px", display: "inline-block" }} onClick={() => navigate("/")}>
                                    Back to Dashboard
                                </button>
                            </div>
                        ) : (
                            <>
                                {fields.map(f => (
                                    <div key={f.key} className="submissions-card" style={{ padding: "16px 18px" }}>
                                        <label className="upload-label" style={{ display: "block", marginBottom: 8, fontSize: 13, fontWeight: 600 }}>
                                            {feedbackMap[f.key]}
                                        </label>
                                        {f.type === "textarea" ? (
                                            <textarea
                                                className="pr-submit-notes"
                                                rows={3}
                                                value={form[f.key]}
                                                onChange={e => handleChange(f.key, e.target.value)}
                                                disabled={submitting}
                                            />
                                        ) : (
                                            <input
                                                className="upload-input"
                                                style={{ width: "100%", boxSizing: "border-box" }}
                                                type="text"
                                                value={form[f.key]}
                                                onChange={e => handleChange(f.key, e.target.value)}
                                                disabled={submitting}
                                            />
                                        )}
                                    </div>
                                ))}

                                <div className="submissions-card" style={{ padding: "16px 18px" }}>
                                    <p style={{ fontSize: 13, fontWeight: 600, margin: "0 0 8px" }}>{feedbackMap.name}</p>
                                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                                        <div>
                                            <label className="upload-label" style={{ display: "block", marginBottom: 4 }}>Name</label>
                                            <input
                                                className="upload-input"
                                                style={{ width: "100%", boxSizing: "border-box" }}
                                                type="text"
                                                placeholder="Your name"
                                                value={form.name}
                                                onChange={e => handleChange("name", e.target.value)}
                                                disabled={submitting}
                                            />
                                        </div>
                                        <div>
                                            <label className="upload-label" style={{ display: "block", marginBottom: 4 }}>Email</label>
                                            <input
                                                className="upload-input"
                                                style={{ width: "100%", boxSizing: "border-box" }}
                                                type="email"
                                                placeholder="your@email.com"
                                                value={form.followUpEmail}
                                                onChange={e => handleChange("followUpEmail", e.target.value)}
                                                disabled={submitting}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {error && <p className="chpw-error">{error}</p>}

                                <button
                                    className="start-analysis-btn"
                                    style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}
                                    onClick={handleSubmit}
                                    disabled={submitting}
                                >
                                    <Send size={14} />
                                    {submitting ? "Submitting..." : "Submit Feedback"}
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
}
